export const FETCH_CHARTS_REQUEST = 'FETCH_CHARTS_REQUEST';
export const FETCH_CHARTS_SUCCESS = 'FETCH_CHARTS_SUCCESS';
export const FETCH_CHARTS_FAILURE = 'FETCH_CHARTS_FAILURE';